import { Directive, ElementRef, Input, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DynamicLabelService } from '../../services/school/dynamic-label.service';

@Directive({
  selector: '[appDynamicLabel]'
})
export class DynamicLabelDirective implements OnInit, OnDestroy {
  @Input() appDynamicLabel: string;
  @Input() fallback: string = '';
  
  private destroy$ = new Subject<void>();

  constructor(
    private el: ElementRef,
    private dynamicLabelService: DynamicLabelService
  ) {}

  ngOnInit(): void {
    if (!this.appDynamicLabel) {
      console.warn('DynamicLabelDirective: No label key provided');
      return;
    }

    // Get the appropriate label based on the key
    this.getLabelForKey(this.appDynamicLabel).pipe(
      takeUntil(this.destroy$)
    ).subscribe(label => {
      this.el.nativeElement.textContent = label || this.fallback;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private getLabelForKey(key: string) {
    switch (key.toLowerCase()) {
      case 'subject':
      case 'course':
        return this.dynamicLabelService.subjectLabel;
      case 'student':
      case 'learner':
        return this.dynamicLabelService.studentLabel;
      case 'evaluation':
      case 'assessment':
        return this.dynamicLabelService.evaluationLabel;
      case 'term':
        return this.dynamicLabelService.termLabel;
      case 'semester':
        return this.dynamicLabelService.semesterLabel;
      case 'courseregistration':
        return this.dynamicLabelService.courseRegistrationLabel;
      case 'studentregistration':
        return this.dynamicLabelService.studentRegistrationLabel;
      case 'academiclevel':
        return this.dynamicLabelService.academicLevelLabel;
      case 'sequence':
        return this.dynamicLabelService.sequenceLabel;
      case 'department':
        return this.dynamicLabelService.departmentLabel;
      case 'specialization':
        return this.dynamicLabelService.specializationLabel;
      default:
        console.warn(`DynamicLabelDirective: Unknown label key: ${key}`);
        return this.dynamicLabelService.subjectLabel; // fallback
    }
  }
}
